<mat-dialog-content id="inputText" class="helpDialog">
  <div class="supportpage-cmp">
    <div class="logo"><img src="assets/images/EcolabLogo.svg" alt="Ecolab Title" /></div>
    <div class="cancel" (click)="onNoClick()"><img src="assets/images/cancel.svg" alt="close" /></div>
  </div>
  <div class="supporttitle">
    <h4 class="supportpage">Support Page</h4>
    <input placeholder="search" class="search" type="text" [(ngModel)]="query_conversation" />
  </div>
  <div class="support-content">
    <div class="support-content-tab">
      <!-- <div class="supportImage"><img src="assets/images/Logistics_Tracking.svg" alt="Tracking data" /></div> -->
      <div class="supportContent">
        <p class="helpTitle" appHighlight [content]="helpQues" [searchTerm]="query_conversation"
        [caseSensitive]="false"></p>
        <p class="Incorrect" appHighlight [content]="helpAns" [searchTerm]="query_conversation"
          [caseSensitive]="false"> </p>
          <table style="width:75%">
            <tr>
              
              <th class="content-padding blue-background">User type</th>
              <th class="content-padding blue-background">Email</th>
            </tr>
            <tr>
              
              <td class="content-padding"><span appHighlight [content]="userType1" [searchTerm]="query_conversation" [caseSensitive]="false"></span></td>
              <td class="content-padding"><span appHighlight [content]="userEmail1" [searchTerm]="query_conversation" [caseSensitive]="false"></span></td>
            </tr>
            <tr>
             
              <td class="content-padding"><span appHighlight [content]="userType2" [searchTerm]="query_conversation" [caseSensitive]="false"></span></td>
              <td class="content-padding"><span appHighlight [content]="userEmail2" [searchTerm]="query_conversation" [caseSensitive]="false"></span></td>
            </tr>

          </table>
          <br>

          <br>
          <p class="Incorrect" appHighlight [content]="alternateHelp" [searchTerm]="query_conversation"
          [caseSensitive]="false"> </p>
          <span appHighlight [content]="kbArticle1" [searchTerm]="query_conversation"
          [caseSensitive]="false"></span><br>
          <span appHighlight [content]="kbArticle2" [searchTerm]="query_conversation"
          [caseSensitive]="false"></span><br>
          <span appHighlight [content]="kbArticle3" [searchTerm]="query_conversation"
          [caseSensitive]="false"></span><br>
          <span appHighlight [content]="kbArticle4" [searchTerm]="query_conversation"
          [caseSensitive]="false"></span>
      </div>
    </div>
    <div class="support-content-tab">
      <!-- <div class="supportImage"><img src="assets/images/Logistics_Tracking.svg" alt="Tracking data" /></div> -->
      <div class="supportContent">
        <p class="helpTitle" appHighlight [content]="whatIsProductTeam" [searchTerm]="query_conversation"
        [caseSensitive]="false"></p>
        <p class="Incorrect" appHighlight [content]="productTeamAns" [searchTerm]="query_conversation"
          [caseSensitive]="false"> </p>
        
      </div>
    </div>
    <div class="support-content-tab">
      <div class="supportContent">
        <p class="helpTitle" appHighlight [content]="escalationPoc" [searchTerm]="query_conversation"
        [caseSensitive]="false"></p>
        <p class="Incorrect" appHighlight [content]="escalationPocInfo" [searchTerm]="query_conversation"
          [caseSensitive]="false"> </p>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions style="display:none;" align="end">
</mat-dialog-actions>